'use client'

import React, { useState } from 'react'
import { Faqs } from '@/services/dataTypes'
import { ChevronDown, ChevronUp } from 'lucide-react'

interface Props {
    merchantName: string
    faqs?: Faqs[]
}

const StoreFaqs = ({ merchantName, faqs = [] }: Props) => {
    const [openFaqs, setOpenFaqs] = useState<Record<number, boolean>>({ 0: true })
    const validFaqs = faqs.filter(faq => faq?.question && faq?.answer)

    if (!validFaqs.length) return null

    const toggleFaq = (index: number) => {
        setOpenFaqs(current => ({ ...current, [index]: !current[index] }))
    }

    return (
        <section id="faqs" className="scroll-mt-24 border-t border-slate-200/80 bg-white py-14 md:py-16">
            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-xl sm:text-2xl font-bold text-[#071822] mb-5">
                    {merchantName} Coupon FAQs
                </h2>
                <div className="space-y-3 max-w-4xl">
                    {validFaqs.map((faq, index) => {
                        const isOpen = !!openFaqs[index]

                        return (
                            <div key={index} className="rounded-2xl border border-slate-200/90 bg-white shadow-xs overflow-hidden">
                                <button
                                    type="button"
                                    onClick={() => toggleFaq(index)}
                                    className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left cursor-pointer hover:bg-slate-50/50 transition-colors"
                                >
                                    <span className="text-sm sm:text-base font-bold text-[#071822]">{faq.question}</span>
                                    <span className="text-slate-400 shrink-0">
                                        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                    </span>
                                </button>
                                {isOpen && (
                                    <div className="px-5 sm:px-6 pb-6 pt-0 text-xs sm:text-sm text-slate-800 leading-relaxed border-t border-slate-100">
                                        <div className="pt-3" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default StoreFaqs
